import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@mui/material';

// A Home feature component: a suggested-article card — cover image, title and a
// one-line summary. Clickable via CardActionArea (which owns the cursor/hover),
// so no per-instance sx at the call site.
const ArticleCard = ({
  title,
  summary,
  onClick,
}: {
  title: string;
  summary: string;
  onClick?: () => void;
}) => (
  <Card>
    <CardActionArea onClick={onClick}>
      {/* cover image placeholder */}
      <Box sx={{ height: 140, bgcolor: 'custom.neutral.200' }} />
      <CardContent>
        <Typography variant='h6'>{title}</Typography>
        <Typography variant='body2' color='text.secondary'>
          {summary}
        </Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

export default ArticleCard;
